import { bindable, inject } from 'aurelia';
import { IZeusClient, ZeusClient } from '@services/graphql-service/zeus-client';

export interface IFeedbackComponentOptions {
  btnTitle: string;
  title: string;
  contactLink: string;
  contactText: string;
  typeMessage: string;
  success: string;
  sucessTimeout: number;
  color: string;
  primaryColor: string;
  inputPlaceholder: string;
  submitText: string;
  backText: string;
  emptyMessageError?: string;

  types: IFeedbackComponentType[]
}

export interface IFeedbackComponentType {
  id: string,
  text: string,
  icon: string,
}

@inject(IZeusClient)
export class FeedbackComponent {
  private opened = false;
  private showThanks = false;
  private showFeedbackForm = false;
  private showButtonList = true;
  private message: string;
  private selectedItem: IFeedbackComponentType;

  private errorMessage: string;

  @bindable public options: IFeedbackComponentOptions;

  constructor(
    readonly zeusClient: ZeusClient,
  ) { }

  bound() {
    this.options = {
      btnTitle: 'Feedback',
      title: 'Feedback da Empresa',
      contactLink: 'mailto:thomasgomes@gtmcapital.com.br',
      contactText: 'Ou envie um email!',
      success: 'Obrigado! 👊',
      sucessTimeout: 2000,
      backText: 'Voltar',
      emptyMessageError: 'A mensagem não pode ser vazia!',
      inputPlaceholder: 'Seu feedback vai aqui!',
      submitText: 'Enviar',
      color: 'rgb(2, 500, 100)',
      primaryColor: 'rgb(2, 125, 199)',
      typeMessage: 'Que tipo de feedback você tem?',
      types: [
        { icon: '😁', id: 'feedback-item-general', text: 'Feedback Geral' },
        { icon: '💡', id: 'feedback-item-idea', text: 'Eu tenho uma ideia' },
        { icon: '🐞', id: 'feedback-item-bug', text: 'Eu encontrei um problema' }
      ]
    };
  }

  async validateMessage(): Promise<boolean> {
    if (this.message === undefined || this.message === '') {
      this.errorMessage = this.options.emptyMessageError;
      return false;
    } else {
      this.errorMessage = '';
      return true;
    }
  }

  async submitFuctionProxy() {
    try {
      if (!this.message) throw new Error(this.options.emptyMessageError);

      await this.zeusClient.insertUserFeedback({
        feedbackType: this.selectedItem.id,
        message: this.message,
      });

      this.message = '';
      this.selectedItem = null;

      this.goBack()
      this.opened = false;
      this.showThanks = true;

      setTimeout(() => { this.showThanks = false }, this.options.sucessTimeout);
    } catch (e) {
      this.errorMessage = e.message;
    }
  }

  openModal() {
    if (this.showThanks === true) return
    this.opened = true;
  }

  toggleFeedbackForm(item: IFeedbackComponentType) {
    this.selectedItem = item;

    this.showFeedbackForm = !this.showFeedbackForm;
    this.showButtonList = !this.showButtonList;
  }

  goBack() {
    this.showFeedbackForm = false;
    this.showButtonList = true;
  }
}